<section class="hero-section">
    <div class="container">
        <div class="row align-items-center gy-5">
            <!-- Left Content -->
            <div class="col-lg-6">
                <h1 
                    class="display-4 mb-1" 
                    style="color: #024423; font-weight: 900; font-size: 3rem;"
                    data-aos="fade-right"
                    data-aos-delay="100">
                    VAIDS 2026
                </h1>
                <h4 
                    class="fw-semibold mb-3 fs-5" 
                    style="color: #3C3F64;"
                    data-aos="fade-right"
                    data-aos-delay="200">
                    Voluntary Assets, Income Declaration & Tax Regularisation Scheme
                </h4>
                <div 
                    class="mb-4 fw-light" 
                    style="color: #6B7280; font-size: 15px;"
                    data-aos="fade-right"
                    data-aos-delay="300">
                    <p class="mb-1">
                        Get official answers on regularising your tax status in Anambra State under the new scheme window.
                    </p>
                </div>
                <a 
                    [routerLink]="'/user/vaids'" 
                    class="cta-btn btn mt-4 px-4 py-2 rounded-2 fs-16 d-flex align-items-center justify-content-center gap-3" 
                    data-aos="fade-right"
                    data-aos-delay="300">
                    <p class="mb-0">Get Started Now</p>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.22656 10.7643H16.7865M10.5065 17.0443L16.7865 10.7643L10.5065 4.48438" stroke="white" stroke-width="1.53795" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>

            <!-- Illustration -->
            <div class="col-lg-6">
                <div 
                    class="hero-illustration"
                    data-aos="fade-down"
                    data-aos-delay="100">
                    <img
                        src="/assets/svg/vaids-illustration-1.svg"
                        class="img-fluid"
                        alt="VAIDS Illustration">
                </div>

                <!-- Statistics -->
                <!-- <div class="row justify-content-center mt-1 g-1">
                    <div class="col-md-4">
                        <div 
                            class="stat-card"
                            data-aos="zoom-in"
                            data-aos-delay="100">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#008000" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <div>
                                <h5>2 Months</h5>
                                <small>Window Period</small>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-md-4">
                        <div 
                            class="stat-card yellow"
                            data-aos="zoom-in"
                            data-aos-delay="200">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#008000" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div style="color: #28533A;">
                                <h5>6 Years</h5>
                                <small>Tax Coverage</small>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div 
                            class="stat-card dark"
                            data-aos="zoom-in"
                            data-aos-delay="300">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#00FF00" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div>
                                <h5>40 Questions</h5>
                                <small>Answered</small>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</section>